const t = ".sl-dialog{background:hsl(var(--sl-hsl-background));color:hsl(var(--sl-hsl-foreground));border:none;border-radius:var(--sl-radius-lg);box-shadow:var(--sl-shadow-lg);padding:0;max-width:90vw;max-height:90vh;max-height:90dvh;overflow:hidden}.sl-dialog::backdrop{background:hsl(var(--sl-hsl-foreground) / 0.5)}@supports (backdrop-filter:blur(4px)){.sl-dialog::backdrop{backdrop-filter:blur(4px)}}.sl-dialog[open]{display:flex;flex-direction:column;animation:dialogShow 200ms ease-out}.sl-dialog:not([open]){display:none}@keyframes dialogShow{from{opacity:0;transform:scale(0.95) translateY(-10px)}to{opacity:1;transform:scale(1) translateY(0)}}@keyframes dialogHide{from{opacity:1;transform:scale(1) translateY(0)}to{opacity:0;transform:scale(0.95) translateY(-10px)}}.sl-dialog__header{display:flex;align-items:center;justify-content:space-between;padding:var(--sl-spacing-4) var(--sl-spacing-6);border-bottom:1px solid hsl(var(--sl-hsl-border))}.sl-dialog__title{margin:0;font-size:var(--sl-font-size-lg);font-weight:var(--sl-font-weight-medium);color:hsl(var(--sl-hsl-foreground))}.sl-dialog__close{display:flex;align-items:center;justify-content:center;width:2rem;height:2rem;padding:0;background:transparent;border:none;border-radius:var(--sl-radius-md);color:hsl(var(--sl-hsl-muted-foreground));cursor:pointer;transition:all var(--sl-transition-fast)}.sl-dialog__close:hover{background:hsl(var(--sl-hsl-secondary));color:hsl(var(--sl-hsl-secondary-foreground))}.sl-dialog__close:focus-visible{box-shadow:0 0 0 2px hsl(var(--sl-hsl-background)),0 0 0 4px hsl(var(--sl-hsl-ring))}.sl-dialog__body{flex:1;padding:var(--sl-spacing-6);overflow-y:auto}.sl-dialog__footer{display:flex;align-items:center;justify-content:flex-end;gap:var(--sl-spacing-2);padding:var(--sl-spacing-4) var(--sl-spacing-6);border-top:1px solid hsl(var(--sl-hsl-border))}.sl-dialog--sm{width:400px}.sl-dialog--md{width:500px}.sl-dialog--lg{width:700px}.sl-dialog--xl{width:900px}.sl-dialog--full{width:100%;max-width:100%;height:100%;max-height:100%;border-radius:0}@media (max-width:640px){.sl-dialog{max-width:100%;max-height:100%;width:100%;height:100%;border-radius:0}.sl-dialog::backdrop{backdrop-filter:none}.sl-dialog__header{padding:var(--sl-spacing-4);padding-top:max(var(--sl-spacing-4),env(safe-area-inset-top,0))}.sl-dialog__body{padding:var(--sl-spacing-4)}.sl-dialog__footer{padding:var(--sl-spacing-4);padding-bottom:max(var(--sl-spacing-4),env(safe-area-inset-bottom,0))}}";
class o extends HTMLElement {
  constructor() {
    super(), this._returnValue = "", this._pendingOpen = !1, this._savedScrollY = 0, this._closeBtnHandler = null, this._shadow = this.attachShadow({ mode: "open" }), this._dialog = document.createElement("dialog"), this._handleEscapeBound = this._handleEscape.bind(this), this._handleBackdropClickBound = this._handleBackdropClick.bind(this), this._handleCancelBound = this._handleCancel.bind(this), this._handleCloseBound = this._handleClose.bind(this), this._render();
  }
  static get observedAttributes() {
    return ["open", "size", "closable"];
  }
  connectedCallback() {
    this._dialog.addEventListener("cancel", this._handleCancelBound), this._dialog.addEventListener("close", this._handleCloseBound), (this._pendingOpen || this.hasAttribute("open")) && (this._pendingOpen = !1, Promise.resolve().then(() => {
      this.isConnected && this.hasAttribute("open") && this._open();
    }));
  }
  disconnectedCallback() {
    this._dialog.removeEventListener("cancel", this._handleCancelBound), this._dialog.removeEventListener("close", this._handleCloseBound), this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll();
  }
  attributeChangedCallback(e, s, l) {
    s !== l && (e === "open" ? l !== null ? this._open() : this._close() : e === "size" ? this._updateSize(s, l) : e === "closable" && this._updateClosable());
  }
  get open() {
    return this.hasAttribute("open");
  }
  set open(e) {
    e ? this.setAttribute("open", "") : this.removeAttribute("open");
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(e) {
    this.setAttribute("size", e);
  }
  get closable() {
    return !this.hasAttribute("closable") || this.hasAttribute("closable") && this.getAttribute("closable") !== "false";
  }
  set closable(e) {
    e ? this.setAttribute("closable", "true") : this.setAttribute("closable", "false");
  }
  get returnValue() {
    return this._returnValue;
  }
  show() {
    this._dialog.show(), this._addEscapeHandler(), this._addBackdropHandler(), this._disableBodyScroll(), this.setAttribute("open", ""), this._dispatch("sl-dialog-open");
  }
  showModal() {
    this._dialog.showModal(), this._addEscapeHandler(), this._addBackdropHandler(), this._disableBodyScroll(), this.setAttribute("open", ""), this._dispatch("sl-dialog-open");
  }
  close(e) {
    this._returnValue = e || "", this._dialog.close(this._returnValue), this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll(), this.removeAttribute("open");
  }
  _open() {
    if (!this.isConnected) {
      this._pendingOpen = !0;
      return;
    }
    this._dialog.open || this._dialog.showModal(), this._addEscapeHandler(), this._addBackdropHandler(), this._disableBodyScroll(), this._dispatch("sl-dialog-open");
  }
  _close() {
    this._dialog.open && this._dialog.close(), this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll();
  }
  _handleCancel(e) {
    this.closable || e.preventDefault();
  }
  _handleClose() {
    this._removeEscapeHandler(), this._removeBackdropHandler(), this._enableBodyScroll(), this.removeAttribute("open"), this._dispatch("sl-dialog-close");
  }
  _handleEscape(e) {
    e.key === "Escape" && (this.closable || (e.preventDefault(), e.stopPropagation()));
  }
  _handleBackdropClick(e) {
    e.target === this._dialog && (this.closable || (e.preventDefault(), e.stopPropagation()));
  }
  _addEscapeHandler() {
    document.addEventListener("keydown", this._handleEscapeBound);
  }
  _removeEscapeHandler() {
    document.removeEventListener("keydown", this._handleEscapeBound);
  }
  _addBackdropHandler() {
    const e = this._shadow.querySelector(".sl-dialog__backdrop");
    e && e.addEventListener("click", this._handleBackdropClickBound);
  }
  _removeBackdropHandler() {
    const e = this._shadow.querySelector(".sl-dialog__backdrop");
    e && e.removeEventListener("click", this._handleBackdropClickBound);
  }
  _updateSize(e, s) {
    this._dialog && (e && this._dialog.classList.remove(`sl-dialog--${e}`), this._dialog.classList.add(`sl-dialog--${s || "md"}`));
  }
  _updateClosable() {
    const e = this._shadow.querySelector(".sl-dialog__close");
    e && (e.style.display = this.closable ? "flex" : "none");
  }
  _disableBodyScroll() {
    this._savedScrollY = window.scrollY, document.body.style.position = "fixed", document.body.style.top = `-${this._savedScrollY}px`, document.body.style.left = "0", document.body.style.right = "0", document.body.style.overflow = "hidden";
  }
  _enableBodyScroll() {
    document.body.style.position = "", document.body.style.top = "", document.body.style.left = "", document.body.style.right = "", document.body.style.overflow = "", window.scrollTo(0, this._savedScrollY);
  }
  _dispatch(e) {
    this.dispatchEvent(
      new CustomEvent(e, {
        bubbles: !0,
        composed: !0,
        detail: { returnValue: this._returnValue }
      })
    );
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${t}</style>
      <dialog class="sl-dialog sl-dialog--${this.size}">
        <div class="sl-dialog__backdrop"></div>
        <div class="sl-dialog__container">
          <header class="sl-dialog__header">
            <slot name="title">
              <h2 class="sl-dialog__title"></h2>
            </slot>
            <button class="sl-dialog__close" aria-label="Close dialog" ${this.closable ? "" : 'style="display: none"'}>×</button>
          </header>
          <main class="sl-dialog__body">
            <slot></slot>
          </main>
          <footer class="sl-dialog__footer">
            <slot name="footer"></slot>
          </footer>
        </div>
      </dialog>
    `, this._dialog = this._shadow.querySelector("dialog");
    const e = this._shadow.querySelector(".sl-dialog__close");
    e && (this._closeBtnHandler = () => this.close(), e.addEventListener("click", this._closeBtnHandler));
  }
}
typeof customElements < "u" && !customElements.get("sl-dialog") && customElements.define("sl-dialog", o);
export {
  o as SlDialogElement
};
//# sourceMappingURL=sl-dialog.js.map
